import { Box, Icon, Skeleton, Typography } from '@mui/material'
import ColoredTooltip from 'src/components/Tooltip/ColoredTooltip'
import { formatCurrency } from 'src/utils/functions'
import { ProblematicType } from './Drawer/ErrorInsightsThemeDrawer'

interface ErrorItemChipProps {
  type: ProblematicType
  error?: string
  errorCharge?: number
  loading?: boolean
  active?: boolean
  onClick?: (type: ProblematicType, name: string) => void
}

const ErrorItemChip = ({ type, error, errorCharge, loading, active, onClick }: ErrorItemChipProps) => {
  return (
    <Box
      border="1px solid #E6E6E6"
      borderRadius="13px"
      height="26px"
      width="100%"
      px={1.5}
      display="flex"
      alignItems="center"
      gap={0.5}
      position="relative"
      sx={{
        ...(onClick && {
          cursor: 'pointer',
          '&:hover': {
            bgcolor: active ? '#196E8220' : '#F3F3F3'
          },
          bgcolor: active ? '#196E8220' : '#fff'
        })
      }}
      onClick={() => onClick && onClick(type, error)}>
      {loading ? (
        <Skeleton
          variant="rounded"
          height="14px"
          width="100%"
        />
      ) : (
        <>
          <Icon sx={{ color: '#000', fontSize: '12px', position: 'absolute', left: '4px' }}>
            {type === 'theme' && 'label'}
            {type === 'item' && 'category'}
            {type === 'location' && 'museum'}
          </Icon>
          <ColoredTooltip title={error?.length > 25 ? error : null}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
              pl={1}
              width="100%">
              <Typography
                fontSize={12}
                color="#000"
                fontWeight={600}
                lineHeight="initial"
                noWrap>
                {error}
              </Typography>
              <Typography
                fontSize={12}
                color="#E52E2E"
                fontWeight={600}
                lineHeight="initial">
                {formatCurrency(errorCharge, { maxFractionDigits: 2 })}
              </Typography>
            </Box>
          </ColoredTooltip>
        </>
      )}
    </Box>
  )
}

export default ErrorItemChip
